import * as api from "@/api/record";
import { RecordSignature } from "@/api/record";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { UserSignature } from "@/api/user";
import { useLogin } from "@/hooks";

export function useGetRecordSignatures(recordId: string) {
  const queryKey = ["signatures", recordId];
  return useQuery(queryKey, () => api.getRecordSignatures(recordId));
}

export function useSignSignature(signature: RecordSignature) {
  const queryClient = useQueryClient();
  return useMutation((userSignature?: UserSignature) => api.signSignature(signature, userSignature), {
    onSuccess: () => {
      queryClient.invalidateQueries(["signatures", signature.recordId]);
    },
  });
}

export function useGetRecordAttachments(recordId: string) {
  const queryKey = ["attachments", recordId];
  return useQuery(queryKey, () => api.getRecordAttachments(recordId));
}

export function useGetReferenceDocuments() {
  const { isLoggedIn } = useLogin();
  return useQuery("references", api.getReferenceDocuments, {
    enabled: isLoggedIn,
    refetchOnWindowFocus: false,
  });
}
